import { forwardRef } from "react";
import UnchainedForm, { FormProps } from "../../common/components/form/Form";
import UnchainedFormField, {
  FormFieldProps,
} from "../../common/components/form/FormField";
import UnchainedInput, { InputProps } from "../../common/components/form/Input";
import UnchainedSelect, {
  SelectProps,
} from "../../common/components/form/Select";
import UnchainedTextarea from "../../common/components/form/Textarea";
import UnchainedCheckboxFormField, {
  CheckboxFormFieldProps,
} from "../../common/components/form/CheckboxFormField";
export const FormRaw = (props: FormProps, ref) => (
  <UnchainedForm ref={ref} className="publicare-form" {...props} />
);

export const Form = forwardRef(FormRaw);

const CheckboxFormFieldRaw = (props: CheckboxFormFieldProps, ref) => (
  <UnchainedCheckboxFormField
    ref={ref}
    className="d-flex align-items-start"
    errorWrapperClassName="form-field-error-wrapper"
    {...props}
  />
);
export const CheckboxFormField = forwardRef(CheckboxFormFieldRaw);

const InputRaw = (props: InputProps, ref) => (
  <UnchainedInput ref={ref} className="form-field-input" {...props} />
);
export const Input = forwardRef(InputRaw);

const SelectRaw = (props: SelectProps, ref) => (
  <UnchainedSelect ref={ref} className="form-field-select" {...props} />
);
export const Select = forwardRef(SelectRaw);

const TextareaRaw = (props, ref) => (
  <UnchainedTextarea ref={ref} className="form-field-textarea" {...props} />
);
export const Textarea = forwardRef(TextareaRaw);

const FormFieldRaw = (
  {
    inputWrapperClassName,
    errorWrapperClassName,
    labelWrapperClassName,
    ...props
  }: FormFieldProps & { [key: string]: any },
  ref,
) => (
  <UnchainedFormField
    ref={ref}
    className="form-field"
    inputWrapperClassName={`form-field-input-wrapper ${inputWrapperClassName || ""}`}
    labelWrapperClassName={`form-field-label-wrapper ${labelWrapperClassName || ""}`}
    errorWrapperClassName={`form-field-error-wrapper ${errorWrapperClassName || ""}`}
    InputField={Input}
    {...props}
  />
);
export const FormField = forwardRef(FormFieldRaw);
